import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../Pages/Homepage.css';

import Navbar from '../../commonComponents/Navbar';
import ContactBanner from '../../Componentsss/Contactus/ContactBanner/ContactBanner';
import ContactLinks from '../../Componentsss/Contactus/ContactLinks/ContactLinks';
import MapContact from '../../Componentsss/Contactus/MapContact/MapContact';
import Presence from '../../Componentsss/Contactus/Presence/Presence';
import ConnectForm from '../../Componentsss/Contactus/ConnectForm/ConnectForm';
import Scan from '../../Componentsss/Contactus/Scan/Scan';
import Footer from '../../commonComponents/Footer';

const ContactUs = () => {

  const location = useLocation();
  const presenceRef = useRef(null);

  useEffect(() => {
    if (location.state?.scrollTo === 'Presence') {
      presenceRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [location]);
  
  const [bannerLoaded, setBannerLoaded] = useState(false);

  return (
    <>
      {bannerLoaded && <Navbar />}
      <ContactBanner onLoad={() => setBannerLoaded(true)} />
      {bannerLoaded && (
        <>
        <ContactLinks />
        <MapContact />
        <div ref={presenceRef}>
          <Presence />
        </div>
        <ConnectForm />
        <Scan />
        <Footer />
        </>
      )}
      
    </>
  )
}

export default ContactUs